(function () {
  Flint.file('mframework/views/sortable.js', function (require) {
    /*
      Wrapper for Sortable
      https://github.com/RubaXa/Sortable
    */

    Flint.staticStyles('Sortable', {
      '$ghost': '#_flintapp ghost.Sortable, #_flintapp .Sortable.ghost, #_flintapp .ViewSortable.ghost, #_flintapp .Sortable > .ghost'
    }, {
      '$ghost': {
        opacity: 0
      }
    });
    Flint.viewRoots["Sortable"] = 'sortable';
    Flint.view('Sortable', function (view, on, $) {
      var pro = initPro(view, {
        children: atom(),
        animation: M.defaultAtom(150),
        enabled: M.defaultAtom(true),
        ghostClass: M.defaultAtom('ghost'),
        handle: atom(),
        filter: M.defaultAtom('.noDrag'),
        group: atom()
      });

      var children = pro.children.derive(function (propChildren) {
        if (propChildren instanceof Array) {
          return propChildren;
        } else {
          return [propChildren];
        }
      });

      var wrapper = atom();
      var sortable = atom();

      var initSortable = function initSortable() {
        if (sortable.get()) {
          sortable.get().destroy();
        }
        sortable.set(window.Sortable.create(wrapper.get(), {
          animation: pro.animation.get(),
          ghostClass: pro.ghostClass.get(),
          handle: pro.handle.get(),
          filter: pro.filter.get(),
          group: pro.group.get(),

          onStart: view.props.onStart,
          onEnd: view.props.onEnd,
          onAdd: view.props.onAdd,
          onUpdate: view.props.onUpdate,
          onSort: view.props.onSort,
          onRemove: view.props.onRemove,
          onFilter: view.props.onFilter,
          onMove: view.props.onMove
        }));
      };

      wrapper.react(function (wrapper) {
        if (wrapper) {
          if (pro.enabled.get()) {
            initSortable();
          }
        } else {
          if (sortable.get()) {
            sortable.get().destroy();
            sortable.set(null);
          }
        }
      });view.render(function () {
        return view.el(
          ['sortable', 1],
          { key: pro.enabled.get() ? children.get().map(function (c) {
              return c.key;
            }).join('\n') : 'frozen',
            ref: wrapper.set.bind(wrapper)
          },
          children.get()
        );
      });
    });
  })
})();
//# sourceMappingURL=sortable.js.map
